import * as Yup from 'yup';
import { useAddressValidationSchema } from '@components/form/address-panel/address-schema';
import { useIdentifierValidationSchema } from '@components/form/identifier-field/form-identifier-schema';
import { DictInsuranceCompany } from '@models';

export function useValidationSchema({
  includeInternational,
}: {
  includeInternational?: boolean;
}) {
  const addressValidation = useAddressValidationSchema();
  const identifierValidationSchema = useIdentifierValidationSchema({
    includeInternational,
  });

  return Yup.object<DictInsuranceCompany>().shape({
    name: Yup.string().nullable().required(),
    identifier: identifierValidationSchema,
    address: addressValidation,
  });
}
